module.exports = __webpack_public_path__ + "img/24.962bfa17.jpg";